export default __webpack_public_path__ + "static/media/LAS0280.34I-32603_-17871_0.ef028b5c.jpg";